import { Action } from '@ngrx/store'

export const SET_SEARCH_TERM = '[Search] Set Search Term'
export const CLEAR_SEARCH_TERM = '[Search] Clear Search Term'

export class SetSearchTerm implements Action {
  readonly type = SET_SEARCH_TERM
  constructor(public payload: string) {}
}
export class ClearSearchTerm implements Action {
  readonly type = CLEAR_SEARCH_TERM
}

export type Actions =
  SetSearchTerm
  | ClearSearchTerm
